export const textFieldsSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: "clamp(50px, 6vh, 80px)",
        fontSize: "clamp(12px, 2.5vh, 15px)",
        borderRadius: "100px",
        backgroundColor: "white",
        "& fieldset": {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&:hover fieldset": {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&.Mui-focused fieldset": {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "piction.highlight",
        },
        "& .MuiInputBase-input": {
            padding: "12px 32px",
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            pl: 5
        }
    }
};

export const textFieldSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: "clamp(50px, 6vh, 80px)",
        fontSize: "clamp(12px, 2.5vh, 15px)",
        borderRadius: "100px",
        backgroundColor: "white",
        "& fieldset": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&:hover fieldset": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&.Mui-focused fieldset": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "piction.highlight",
        },
        "& .MuiInputBase-input": {
            padding: "12px 32px",
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            pl: 5
        }
    }
};

export const textFieldSxAcneConcern = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: "clamp(30px, 4vh, 40px)",
        fontSize: "clamp(12px, 2vh, 13px)",
        borderRadius: "100px",
        backgroundColor: "white",
        "& fieldset": {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&:hover fieldset": {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&.Mui-focused fieldset": {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "piction.highlight",
        },
        "& .MuiInputBase-input": {
            padding: "8px 24px",
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            pl: 3
        }
    }
};

export const textAreaSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: "clamp(50px, 6vh, 80px)",
        fontSize: "clamp(12px, 2.5vh, 15px)",
        borderRadius: "25px",
        backgroundColor: "white",
        "& fieldset": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&:hover fieldset": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "grayTones.border",
        },
        "&.Mui-focused fieldset": {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "piction.highlight",
        },

        "& .MuiInputBase-input": {
            padding: "12px 32px",
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
        },
        "& .MuiOutlinedInput-notchedOutline": {
            transition: "border 0.2s ease-in-out",
        }
    }
};

export const continueButtonSx = {
    p: 3,
    pt: 0.5,
    display: "flex",
    justifyContent: "center",
    borderColor: "grayTones.light",
    backgroundColor: "white",
};

export const inputLabelSx = {
    color: "grayTones.main",
    fontSize: "clamp(12px, 2.5vh, 15px)",
    fontWeight: 600,
    pt: 0,
    pb: 0,
    pl: 3,
    "& .MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.85)",
    },
};

export const checkboxSx = {
    margin: 0,
    border: "2px solid",
    borderColor: "grayTones.piction",
    borderRadius: "25px",
    backgroundColor: "white",
    pl: 2,
    pt: 0.5,
    pb: 0.5,
    pr: 2,
    width: "100%",
    "& .MuiFormControlLabel-label": {
        width: "100%",
        textAlign: "left",
        fontSize: "clamp(12px, 2.5vh, 15px)",
        fontWeight: 600
    },
};

export const moveButtonSx = {
    minHeight: "clamp(50px, 6vh, 80px)",
    fontSize: "clamp(12px, 2.5vh, 15px)",
    pl: 4
};

export const phoneInputSx = {
    width: "100%",
    borderRadius: "100px",
    backgroundColor: "white",
    minHeight: "clamp(50px, 6vh, 80px)",
    fontSize: "clamp(12px, 2.5vh, 15px)",
    "& fieldset": {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "grayTones.border",
    },
    "&:hover fieldset": {
        borderWidth: "1px",
        borderColor: "grayTones.border",
    },
    "&.Mui-focused fieldset": {
        borderWidth: "1px",
        borderColor: "piction.highlight",
    },
    "& .MuiInputBase-input": {
        padding: "12px 32px",
        fontFamily: "Inter, sans-serif",
        fontWeight: 600,
    },
};

export const cardStyle = {
    borderRadius: "25px",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderWidth: "0.5px",
    borderStyle: "solid",
    borderColor: "grayTones.border",
    mb: 2,
    fontSize: "clamp(10px, 2.5vh, 13px)"
};

export const fabStyle = {
    position: 'fixed',
    bottom: 80,
    right: 20,
    color: 'white',
    bgcolor: 'piction.highlight',
    '&:hover': {
        bgcolor: 'piction.highlight',
    },
};

export const typographySx = {
    fontFamily: "Sentient",
    fontSize: "clamp(14px, 3vh, 28px)",
    fontWeight: 400,
    mt: "clamp(0.5rem, 1.5vh, 1.5rem)",
    mb: "clamp(0.5rem, 1.5vh, 1.5rem)",
};

export const caseDtlstypographySx = {
    fontFamily: "Sentient",
    fontSize: "clamp(10px, 3vh, 20px)",
    fontWeight: 400,
    mt: "clamp(0.5rem, 1.5vh, 1.5rem)",
    mb: "clamp(0.5rem, 1.5vh, 1.5rem)",
};

export const textFieldBorderlessSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: "clamp(50px, 6vh, 80px)",
        fontSize: "clamp(12px, 2.5vh, 15px)",
        fontFamily: "Inter, sans-serif",
        fontWeight: 600,
        borderRadius: 0,
        backgroundColor: "transparent",
        "& fieldset": {
            border: "none",
        },
        "&:hover fieldset": {
            border: "none",
        },
        "&.Mui-focused fieldset": {
            border: "none",
        },
        "& .MuiInputBase-input": {
            padding: "12px 32px",
        },
    },
};

export const textFieldBorder = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: "clamp(50px, 6vh, 80px)",
        fontSize: "clamp(12px, 2.5vh, 15px)",
        fontFamily: "Inter, sans-serif",
        fontWeight: 600,
        borderRadius: "100px",
        backgroundColor: "transparent",
        "& fieldset": {
            border: "2px solid",
            borderColor: "grayTones.border",
        },
        "&:hover fieldset": {
            border: "2px solid",
            borderColor: "grayTones.border",
        },
        "&.Mui-focused fieldset": {
            border: "2px solid",
            borderColor: "grayTones.border",
        },
        "& .MuiInputBase-input": {
            padding: "12px 32px",
        },
    },
};

export const singleFieldSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        minHeight: "clamp(50px, 6vh, 80px)",
        fontSize: "clamp(12px, 2.5vh, 15px)",
        fontFamily: "Inter, sans-serif",
        fontWeight: 600,
        borderRadius: "100px",
        backgroundColor: "white",
        "& fieldset": {
            borderWidth: "2px",
            borderColor: "grayTones.border",
        },
        "&:hover fieldset": {
            borderWidth: "2px",
            borderColor: "grayTones.border",
        },
        "&.Mui-focused fieldset": {
            borderWidth: "2px",
            borderColor: "piction.highlight",
        },
        "& .MuiInputBase-input": {
            padding: "12px 32px",
        },
    },
};